var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1923 2.1316L15.6667 3.60601L17.0794 2.19323C16.5738 2.06701 16.0447 2 15.5 2C15.0521 2 14.6147 2.04531 14.1923 2.1316Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6137 2.67432L14.606 4.66662L12.1667 7.10596L10.037 4.97631C10.6708 3.99572 11.5614 3.19666 12.6137 2.67432Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7273 4.66666L18.6055 2.78845C19.7051 3.38756 20.6124 4.29493 21.2115 5.39445L19.3333 7.27266L16.7273 4.66666Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8068 6.92053L20.394 8.3333L21.8684 9.80771C21.9547 9.38527 22 8.94791 22 8.49997C22 7.95524 21.933 7.42616 21.8068 6.92053Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 9.39404L21.3256 11.3864C20.8033 12.4387 20.0042 13.3293 19.0236 13.9631L16.894 11.8334L19.3333 9.39404Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.7727L18.2727 8.33329L15.6667 5.72729L13.2273 8.16663L15.8333 10.7727Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5945 14.6552C16.9373 14.8787 16.2328 15 15.5 15C14.4583 15 13.4739 14.755 12.6012 14.3194L7.49068 19.43L4.57007 16.5094L9.68058 11.3988C9.24502 10.5261 8.99999 9.54168 8.99999 8.50002C8.99999 7.7672 9.12126 7.06271 9.34483 6.40552L17.5945 14.6552ZM10.0303 13.9697C9.73742 13.6768 9.26255 13.6768 8.96966 13.9697L7.96966 14.9697C7.67676 15.2626 7.67676 15.7374 7.96966 16.0303C8.26255 16.3232 8.73742 16.3232 9.03032 16.0303L10.0303 15.0303C10.3232 14.7374 10.3232 14.2626 10.0303 13.9697Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43007 20.4907L3.50946 17.5701L2.60506 18.4745C1.79856 19.281 1.79856 20.5886 2.60506 21.3951C3.41157 22.2016 4.71917 22.2016 5.52568 21.3951L6.43007 20.4907Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneAlt2);
export default __webpack_public_path__ + "static/media/microphone-alt-2.3afdaa3e3f9e6eec4b6d9400fa7a67e5.svg";
export { ForwardRef as ReactComponent };